var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{class:`${_vm.isDeck ? 'deck' : 'room flex-grow-0'} ${_vm.hovered ? 'hovered' : ''}
  d-flex justify-center align-items-center flex-shrink-0 mx-1 my-2 px-2`,attrs:{"color":_vm.isDeck ? 'grey lighten-3' : null}},[(!_vm.isDeck)?_c('h6',{staticClass:"text-h6 room-title"},[_vm._v(" "+_vm._s(_vm.getUF("room"))+" "+_vm._s(_vm.room)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }